// client/src/components/Finances/MortgageDetails.js

export default function MortgageDetails({ mortgage, liabilities }) {
  if (!mortgage) {
    return (
      <div className="bg-white shadow rounded-xl p-6 text-sm text-gray-500">
        No mortgage information available.
      </div>
    );
  }

  const safe = (n) => Number(n || 0).toLocaleString();

  return (
    <div className="bg-white shadow rounded-xl p-6">
      <h2 className="text-lg font-semibold mb-4">Mortgage & Liabilities</h2>

      {/* --------------------
          MAIN MORTGAGE PANEL
      --------------------- */}
      <div className="mb-6">
        <p className="text-sm text-gray-500">Lender</p>
        <p className="font-bold text-gray-900">
          {mortgage.lender || "Unknown"}
        </p>

        <div className="grid grid-cols-2 gap-4 mt-3">

          <div>
            <p className="text-sm text-gray-500">Balance</p>
            <p className="font-semibold">
              ${safe(mortgage.balance)}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Interest Rate</p>
            <p className="font-semibold">
              {mortgage.rate ? `${mortgage.rate}%` : "N/A"}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Payment</p>
            <p className="font-semibold">
              ${safe(mortgage.payment)}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Renewal Date</p>
            <p className="font-semibold">
              {mortgage.renewalDate || "Not set"}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Remaining Amortization</p>
            <p className="font-semibold">
              {mortgage.remainingAmortYears
                ? `${mortgage.remainingAmortYears} years`
                : "N/A"}
            </p>
          </div>

        </div>
      </div>

      {/* --------------------
          OTHER LIABILITIES
      --------------------- */}
      {liabilities && liabilities.length > 0 && (
        <div>
          <h3 className="font-medium mb-2">Other Liabilities</h3>

          <div className="space-y-3">
            {liabilities.map((item, idx) => (
              <div
                key={idx}
                className="border rounded-md p-3 flex justify-between items-center"
              >
                <div>
                  <p className="font-medium text-gray-900">{item.name}</p>
                  <p className="text-sm text-gray-500">{item.type}</p>
                </div>

                <div className="text-right">
                  <p className="font-semibold">
                    ${safe(item.balance)}
                  </p>
                  {item.rate && (
                    <p className="text-sm text-gray-500">
                      {item.rate}%
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
